import { useRouter } from 'expo-router';
import { Drawer } from 'expo-router/drawer';
import React from 'react';
import { Pressable, View, useWindowDimensions } from 'react-native';

import ScanLink from '@/components/ScanLink';
import { SignOutForm } from '@/components/SignInForm';
import { ThemedText } from '@/components/ThemedText';
import { ThemedView } from '@/components/ThemedView';
import { IconSymbol } from '@/components/ui/IconSymbol';
import { useNavigationStore } from '@/stores/navigationStore';


function CustomDrawerContent({ navigation }: any) {
  const router = useRouter();
  const { getSelectedBranch, getSelectedCampaign, clearSelectedBranch, setSelectedCampaignId } = useNavigationStore();
  const selectedBranch = getSelectedBranch();
  const selectedCampaign = getSelectedCampaign();
  const branch_short_name = selectedBranch?.branch_short_name || '';
  const branch = selectedBranch?.branch || '';
  const campaignId = selectedCampaign?.boundary_id;
  const campaignName = selectedCampaign?.boundary_name || '';

  const navigateToScreen = (screen: string) => {
    //using router.push instead of router.replace to avoid the error:
    //The specified child already has a parent. You must call removeView() on the child's parent first.
    router.push(screen as any);
    navigation.closeDrawer();
  }

  // Only show branch info and change branch if no campaign is selected
  if (!campaignName && !campaignId) {
    return (
      <ThemedView style={{ flex: 1, padding: 16, justifyContent: 'flex-start', marginTop: 40 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 16 }}>
          <View style={{ flex: 1 }}>
            <ThemedText style={{ fontWeight: 'bold', fontSize: 16 }} numberOfLines={1}>
              {branch || branch_short_name || 'Select'} Branch
            </ThemedText>
          </View>
          <Pressable onPress={async () => { clearSelectedBranch(); setSelectedCampaignId('', null); router.replace('/'); }}>
            <IconSymbol name="arrow.left.arrow.right" size={22} color="#888" />
          </Pressable>
        </View>
        <View style={{ flex: 1 }} />
        <ScanLink />
        <View style={{ marginBottom: 50 }}>
          <SignOutForm />
        </View>
      </ThemedView>
    );
  }

  // Full drawer content if campaign is selected
  return (
    <ThemedView style={{ flex: 1, padding: 16, justifyContent: 'flex-start', marginTop: 40 }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 16 }}>
        <Pressable
          onPress={() => navigateToScreen(`/${branch_short_name}/campaign/`)}
          style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}
        >
          <ThemedText style={{ fontWeight: 'bold', fontSize: 16 }} numberOfLines={1}>
            {branch} Branch
          </ThemedText>
        </Pressable>
        <Pressable onPress={async () => { clearSelectedBranch(); setSelectedCampaignId('', null); router.replace('/'); }}>
          <IconSymbol name="arrow.left.arrow.right" size={22} color="#888" />
        </Pressable>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 16 }}>
        <Pressable
          onPress={() => {navigateToScreen(`/${branch_short_name}/campaign/${campaignId}`)}}
          style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}
        >
          <ThemedText style={{ fontSize: 15 }} numberOfLines={1}>
            {campaignName || 'Campaign'}
          </ThemedText>
        </Pressable>
        <Pressable onPress={async () => { setSelectedCampaignId(branch_short_name, null); if (branch_short_name) { router.replace(`/${branch_short_name}/campaign/`); } else { router.replace('/'); } }}>
          <IconSymbol name="arrow.left.arrow.right" size={22} color="#888" />
        </Pressable>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 16 }}>
        <Pressable
          onPress={() => navigateToScreen(`/${branch_short_name}/campaign/${campaignId}/canvass`)}
          style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}
        >
          <ThemedText style={{ fontSize: 15 }} numberOfLines={1}>
            Canvass
          </ThemedText>
        </Pressable>
        <Pressable onPress={() => navigateToScreen(`/${branch_short_name}/campaign/${campaignId}/canvass`)}>
          <IconSymbol name="chevron.right" size={22} color="#888" />
        </Pressable>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 16 }}>
        <Pressable
          onPress={() => navigateToScreen(`/${branch_short_name}/campaign/${campaignId}/leafleting`)}
          style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}
        >
          <ThemedText style={{ fontSize: 15 }} numberOfLines={1}>
            Leafleting
          </ThemedText>
        </Pressable>
        <Pressable onPress={() => navigateToScreen(`/${branch_short_name}/campaign/${campaignId}/leafleting`)}>
          <IconSymbol name="chevron.right" size={22} color="#888" />
        </Pressable>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 16 }}>
        <Pressable
          onPress={() => navigateToScreen(`/${branch_short_name}/campaign/${campaignId}/phone`)}
          style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}
        >
          <ThemedText style={{ fontSize: 15 }} numberOfLines={1}>
            Phone
          </ThemedText>
        </Pressable>
        <Pressable onPress={() => navigateToScreen(`/${branch_short_name}/campaign/${campaignId}/phone`)}>
          <IconSymbol name="chevron.right" size={22} color="#888" />
        </Pressable>
      </View>
      <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 16 }}>
        <Pressable
          onPress={() => navigateToScreen(`/${branch_short_name}/campaign/${campaignId}/telling`)}
          style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}
        >
          <ThemedText style={{ fontSize: 15 }} numberOfLines={1}>
            Telling
          </ThemedText>
        </Pressable>
        <Pressable onPress={() => navigateToScreen(`/${branch_short_name}/campaign/${campaignId}/telling`)}>
          <IconSymbol name="chevron.right" size={22} color="#888" />
        </Pressable>
      </View>
      <View style={{ flex: 1 }} />
      <ScanLink />
      <View style={{ marginBottom: 50 }}>
        <SignOutForm />
      </View>
    </ThemedView>
  );
}

export default function BranchLayout() {
  const dimensions = useWindowDimensions();
  const isWide = dimensions.width >= 900;

  return (
    <Drawer
      drawerContent={props => <CustomDrawerContent {...props} />}
      screenOptions={({ navigation }) => ({
        drawerType: isWide ? 'permanent' : 'front',
        headerLeft: ({ tintColor }) => (
          <Pressable onPress={() => navigation.toggleDrawer()} style={{ marginLeft: 16 }}>
            <IconSymbol name="chevron.right" size={28} color={tintColor || '#000'} />
          </Pressable>
        ),
      })}
    >
      <Drawer.Screen name="campaign" options={{ title: 'Campaigns', headerShown: false }} />
      <Drawer.Screen name="index" options={{ title: 'Branch' }} />
      <Drawer.Screen name="share" options={{ title: 'Share Access', drawerItemStyle: { display: 'none' } }} />
    </Drawer>
  );
} 